<p mat-dialog-title class="custom-title">App-Installation nicht möglich</p>
<mat-dialog-content class="mat-typography">
    <p class="custom-body-small">Die Installation der App wird durch Ihre aktuelle Browser-/Gerätversion leider nicht unterstützt.</p>
</mat-dialog-content>


